<template>
  <div class="CTI_setting" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="queuePhone" placeholder="请输入技能组号码" title="技能组号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="queueName" placeholder="请输入技能组名称" title="技能组名称"/>
      </div>
      <div class="fixed_search_input">
        <Select
          v-model="rwId"
          clearable
          placeholder="请选择AI流程"
          transfer
          title="AI流程"
        >
          <Option v-for="(ai,index) in aiFlow" :key="index" :value="ai.id+''">{{ai.rwName}}</Option>
        </Select>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="info" class="operation_btn" @click="addQueue" v-if="roleList['a_4-1']">添加</Button>
      </div>
    </div>
    <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width: 20%">技能组号码</th>
            <th class="font_style_set" style="width: 20%">技能组名称</th>
            <th class="font_style_set" style="width: 20%">AI流程</th>
            <th class="font_style_set" style="width: 20%;">创建时间</th>
            <th class="font_style_set" style="width: 20%">操作</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <tr v-for="(item,index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td style="width: 20%;">{{item.queuePhone}}</td>
            <td style="width: 20%;">{{item.queueName}}</td>
            <td style="width: 20%;">{{item.rwName}}</td>
            <td style="width: 20%">{{item.createTime}}</td>
            <td style="width: 20%" class="template_table_btn">
              <span class="search_btn" @click="editQueue(item.id)" v-if="roleList['a_4-2']">编辑</span>
              <span class="search_btn" @click="deleteQueue(item.id,item.queuePhone,item.queueName)" v-if="roleList['a_4-3']">删除</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size="pageSize" :current="currentPage" :page-size-opts="pageSizeList" show-total show-sizer @on-change="changeCurrent" @on-page-size-change="changeSize"></Page>
      <div style="padding-top: 2px">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px">页</div>
    </div>
    <skillsGroupEditPop @closeSkillsGroup="closeSkillsGroup" :aiQueue="true" :showSkillsGroupEdit="showSkillsGroupEdit" :skillId="skillId" :title="title" :lines="lines"></skillsGroupEditPop>
  </div>
</template>

<script>
  import {publicFunClass} from "@/components/js/PublicFunClass";
  import skillsGroupEditPop from '@/components/systemSetup/CTIConfigure/SkillsGroupEditPop.vue'
  export default {
    name: "AIQueue",
    mixins: [publicFunClass],
    props:{
      pageCode:String
    },
    components:{
      skillsGroupEditPop
    },
    data(){
      return {
        showPageCount:0,
        showPublicBtn:false,
        infoTableList:[],
        spinShow:true,
        editable:false,
        tableHeight:{height:''},
        screenHeight:{height:''},
        roleList:JSON.parse(localStorage.getItem("roleList")),
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        speedChangePage:1,
        pageSize:20,
        currentPage:1,
        configInfo:JSON.parse(localStorage.getItem("configInfo")),
        title:'添加AI技能组',
        skillId:'',
        showSkillsGroupEdit:false,
        queuePhone:'',
        queueName:'',
        rwId:'',
        aiFlow:[],
        lines:0,
      }
    },
    methods:{
      initSearch() {
        this.spinShow = true
        let that = this
        let param = {
          pageNum:this.currentPage,
          pageSize: this.pageSize,
          queuePhone: that.queuePhone,
          queueName:that.queueName,
          rwId:that.rwId,
          journalType:'null',
          menuId:'null',
          queueType:'1',
        }
        this.$http.post('skillGroup/toIndex.json',param).then(res=>{
          let response = res.data;
          that.spinShow = false;
          if (response.flag !== '666') {
            that.$Modal.info({
              title:'提示',
              content:response.msg
            })
            return false
          }
          that.infoTableList = response.obj.list.content
          that.lines = response.obj.maxRobotNum
          that.total = response.obj.list.totalSize
        })
      },
      closeSkillsGroup(flag) {
        this.showSkillsGroupEdit=false
        if (flag) {
          this.initSearch()
        }
      },
      addQueue() {
        this.showSkillsGroupEdit=true
        this.skillId=''
        this.title='添加AI技能组'
      },
      editQueue(id) {
        this.showSkillsGroupEdit=true
        this.skillId=id
        this.title='编辑AI技能组'
      },
      deleteQueue(id, queuePhone, queueName) {
        let that = this
        let param = {
          id: id,
          queuePhone: queuePhone,
          journalType: 'AI机器人管理=>AI技能组管理=>删除',
          menuId: 'a_4-3'
        }
        this.$Modal.confirm({
          title: '提示',
          content: '是否确认删除AI技能组：'+queueName+' ?',
          onOk: () => {
            that.$http.post('skillGroup/doDelete.json', param).then(res => {
              let response = res.data
              if (response.flag !== '666') {
                that.$alert(response.msg, '提示', {
                  confirmButtonText: '确定'
                })
                return false
              }
              that.$Message.info('AI技能组删除成功！');
              that.initSearch()
            })
          }
        })
      },
    },
    created() {
      this.tableHeight.height = this.mountHeight(225)
      this.screenHeight.height = this.mountHeight(91)
    },
    watch:{
      pageCode() {
        if (this.pageCode === 'a_4' && this.showPageCount === 0) {
          this.showPageCount++
          this.initSearch()
          this.getAIWorkFlow()
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/aiManager/AIQueue.vue